import { render } from "./SelectPaymentTransition.vue?vue&type=template&id=e2c37a96"
import script from "./SelectPaymentTransition.vue?vue&type=script&lang=js"
export * from "./SelectPaymentTransition.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__